/**
 * Serial port configuration types
 */

/**
 * Serial port configuration options
 * Compatible with Web Serial API SerialOptions
 */
export type SerialPortConfig = {
    baudRate: number;
    dataBits?: 7 | 8;
    stopBits?: 1 | 2;
    parity?: 'none' | 'even' | 'odd';
    flowControl?: 'none' | 'hardware';
};

/**
 * Device-specific configuration
 */
export type DeviceConfig = {
    /** Device description patterns to match */
    descriptionPatterns: Array<string>;
    /** Serial configuration for normal operation */
    serialConfig: SerialPortConfig;
    /** Whether this is a Pico device */
    isPico: boolean;
};

/**
 * Standard serial configuration for FTDI devices (ES4, etc.)
 * Uses 921600 baud rate with hardware flow control
 */
export const FTDI_STANDARD_CONFIG: SerialPortConfig = {
    baudRate: 921600,
    dataBits: 8,
    stopBits: 1,
    parity: 'none',
    flowControl: 'hardware',
};

/**
 * Serial configuration for Pico devices
 * Uses 230400 baud rate with no flow control
 */
export const PICO_CONFIG: SerialPortConfig = {
    baudRate: 230400,
    dataBits: 8,
    stopBits: 1,
    parity: 'none',
    flowControl: 'none',
};

/**
 * Default serial configuration for USB-CDC devices
 * Uses 115200 baud rate (standard USB-CDC)
 */
export const USB_CDC_DEFAULT_CONFIG: SerialPortConfig = {
    baudRate: 115200,
    dataBits: 8,
    stopBits: 1,
    parity: 'none',
    flowControl: 'none',
};

/**
 * Device configurations based on description patterns
 */
export const DEVICE_CONFIGS: Array<DeviceConfig> = [
    // EmStat Pico devices
    {
        descriptionPatterns: ['espico', 'emstatgo-pico', 'sensit', 'wearable-abb'],
        serialConfig: PICO_CONFIG,
        isPico: true,
    },
    // EmStat4 series
    {
        descriptionPatterns: ['emstatgo-4', 'emstat4r', 'es4dev'],
        serialConfig: FTDI_STANDARD_CONFIG,
        isPico: false,
    },
    // PalmSens4
    {
        descriptionPatterns: ['palmsens4', 'ps4'],
        serialConfig: FTDI_STANDARD_CONFIG,
        isPico: false,
    },
    // EmStat3 series
    {
        descriptionPatterns: ['emst', 'lactosens2', 'directsens', 'abt', 'mes'],
        serialConfig: PICO_CONFIG, // ES3 uses 230400
        isPico: false,
    },
];
